import styled, { css } from 'styled-components';
export const Container = styled.div`
  height: 100%;
  width: 100%;
`
export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 4rem;
  padding: 0.9rem ;
  display: flex;
  flex-direction: row-reverse;
  background-color:#f6f6f6;
`
export const Icon = styled.label`
  color:#495057;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: 500;
  margin-left: 0.4rem;
  &:hover{
    color:#1c83e2;
  }
  .icon--{
    font-size: 1.5rem;
  }
  .icon--close{
    font-size: 1.5rem;
    color: #e11f60;
  }
`;

export const Options = styled.ul`
  position: absolute;
  top:3.5rem;
  right:4px;
  z-index: 1;
  min-width: 10rem;
  height:0.5px;
  border-radius: 0.42rem;
  transition: height 260ms ease-in-out;
  overflow: hidden;
  background-color: transparent;
  pointer-events: none;
  li {
    list-style: none;
    display: flex;
    cursor: pointer;
    padding: 0.925rem 1.5rem;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 0.82rem;
    color: transparent;
    gap: 0.5rem;
    .icon--menu{
      font-size: 1rem;
    }
    &:hover {
      color: black;
      background-color:#f5f6f6;
    }
    .x-menu{
      font-size: 1.5rem;
    }
  }
  ${(props) =>
    props.menuOpen &&
    css`
      height:auto;
      background: #fff;
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);
      pointer-events: auto;
      z-index: 9999;
      li{
        color: black;
      }
    `}
 
`
export const Content = styled.div`
  width: 100%;
  height: calc(100% - 6rem);
`
export const Footer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 2.44rem;
  z-index: 1;
  bottom: 0px;
  gap: 0.9rem;
  justify-content: center;
  align-items: center;
  border-top: 4px solid #1d83e2;
  box-shadow: 1px -2px 4px rgba(0, 0, 0, 0.2);
  font-size: 0.897rem;
  color: #6c757d;
  > img {
    cursor: pointer;
    width: 5rem;
  }
  > span:nth-child(2){
    width: 2px;
    height: calc(100% - 20px);
    border-left: solid 2px #abacac;
  }
  .copyright{
    margin-right: 3px;
  }
` 